import { FC } from 'react';
import HTMLReactParser from 'html-react-parser';
import { useSeoBlockContext } from './hooks';

const SeoBlockText: FC = () => {
  const { text } = useSeoBlockContext();

  if (!text) {
    return null;
  }

  return (
    <div>
      {HTMLReactParser(text)}
    </div>
  );
};

export { SeoBlockText };
